// * Copyright 2020 Hologram, Inc. All rights reserved.

export const AA = 'Aa';
export const ACTION_ITEM = 'ActionItem';
export const FILLED_ACTION_ITEM = 'ActionItem--filled';
export const ADMIN = 'Admin';
export const AIRPLANE = 'Airplane';
export const ARROW_BEND_WEST = 'Arrow--bend--west';
export const BRANCH = 'Arrow--branch';
export const ARROW_DECREASE = 'Arrow--decrease';
export const ARROW_EAST = 'Arrow--east';
export const ARROW_EAST_TO_TABLE = 'Arrow--east--to--table';
export const ARROW_INCREASE = 'Arrow--increase';
export const ARROW_LINETO_EAST = 'Arrow--lineinto--east';
export const ARROW_LINETO_NORTH = 'Arrow--lineinto--north';
export const ARROW_LINETO_SOUTH = 'Arrow--lineinto--south';
export const ARROW_LINETO_WEST = 'Arrow--lineinto--west';
export const ARROW_LONG_EAST = 'Arrow--long--east';
export const ARROW_LONG_NORTHEAST = 'Arrow--long--northeast';
export const ARROW_LONG_SOUTHEAST = 'Arrow--long--southeast';
export const ARROW_LONG_SOUTHWEST = 'Arrow--long--southwest';
export const ARROW_LONG_WEST = 'Arrow--long--west';
export const MERGE = 'Arrow--merge';
export const ARROW_NORTH = 'Arrow--north';
export const ARROW_NORTHEAST = 'Arrow--northeast';
export const ARROW_NORTHEAST_SOUTHWEST = 'Arrow--northeastsouthwest';
export const ARROW_NORTHWEST = 'Arrow--northwest';
export const ARROW_SOUTH = 'Arrow--south';
export const ARROW_SOUTHEAST = 'Arrow--southeast';
export const ARROW_SOUTHWEST = 'Arrow--southwest';
export const ARROW_TOLINE_EAST = 'Arrow--toline--east';
export const ARROW_TOLINE_NORTH = 'Arrow--toline--north';
export const ARROW_TOLINE_SOUTH = 'Arrow--toline--south';
export const ARROW_TOLINE_WEST = 'Arrow--toline--west';
export const ARROW_TRIANGLE_EAST = 'Arrow--triangle--east';
export const ARROW_TRIANGLE_NORTH = 'Arrow--triangle--north';
export const ARROW_TRIANGLE_NORTH_SOUTH = 'Arrow--triangle--northsouth';
export const ARROW_TRIANGLE_SOUTH = 'Arrow--triangle--south';
export const ARROW_TRIANGLE_WEST = 'Arrow--triangle--west';
export const ARROW_UTURN = 'Arrow--uturn--east';
export const ARROW_WEST = 'Arrow--west';
export const AUTOREFILL = 'AutoRefill';
export const BEAKER = 'Beaker';
export const BOOK = 'Book--open';
export const CALENDAR = 'Calendar';
export const CART = 'Cart';
export const CELLTOWER = 'CellTower';
export const CHANGEPLAN = 'ChangePlan';
export const CHAT = 'Chat';
export const CHECKMARK_DOUBLE = 'Checkmark--double';
export const CHECKMARK_SINGLE = 'Checkmark--single';
export const CHEVRON_DOUBLE_EAST = 'Chevron--double--east';
export const CHEVRON_DOUBLE_NORTH = 'Chevron--double--north';
export const CHEVRON_DOUBLE_SOUTH = 'Chevron--double--south';
export const CHEVRON_DOUBLE_WEST = 'Chevron--double--west';
export const CHEVRON_NORTH_SOUTH = 'Chevron--northsouth';
export const CHEVRON_SINGLE_EAST = 'Chevron--single--east';
export const CHEVRON_SINGLE_NORTH = 'Chevron--single--north';
export const CHEVRON_SINGLE_SOUTH = 'Chevron--single--south';
export const CHEVRON_SINGLE_WEST = 'Chevron--single--west';
export const CHIP = 'Chip';
export const CIRCLE = 'Circle';
export const CIRCLE_ALERT = 'Circle--alert';
export const CIRCLE_CHECK = 'Circle--check';
export const CIRCLE_CHEVRON_EAST = 'Circle--chevron--east';
export const CIRCLE_CHEVRON_NORTH = 'Circle--chevron--north';
export const CIRCLE_CHEVRON_SOUTH = 'Circle--chevron--south';
export const CIRCLE_CHEVRON_WEST = 'Circle--chevron--west';
export const CIRCLE_INFO = 'Circle--info';
export const CIRCLE_MINUS = 'Circle--minus';
export const CIRCLE_PLUS = 'Circle--plus';
export const CLOSE = 'Close';
export const CLOUD = 'Cloud';
export const COLLAPSE = 'Collapse';
export const CONSOLE = 'Console';
export const CREDIT_CARD = 'CreditCard';
export const DOCUMENT = 'Document';
export const ENVELOPE = 'Envelope';
export const EXPAND = 'Expand';
export const FILTER = 'Filter';
export const GAUGE = 'Gauge';
export const GEAR = 'Gear';
export const GLOBE = 'Globe';
export const HEART = 'Heart';
export const HEARTBEAT = 'Heartbeat';
export const HISTORY = 'History';
export const HOLOGRAM = 'Hologram';
export const HYPER = 'Hyper';
export const INBOUND = 'Inbound';
export const INSPECT = 'Inspect';
export const LIGHTNING = 'Lightning';
export const LIGHTNING_SLASH = 'Lightning--slash';
export const LINK = 'Link';
export const LOCATION = 'Location';
export const LOCK_CLOSED = 'Lock--closed';
export const LOCK_OPEN = 'Lock--open';
export const MAILBOX = 'Mailbox';
export const MENU = 'Menu';
export const MINUS = 'Minus';
export const SHRUNK_MINUS = 'Minus--shrunk';
export const ORGANIZATION = 'Organization';
export const OUTBOUND = 'Outbound';
export const OUTBOUNDTAG = 'OutboundTag';
export const PAPERPLANE = 'Paperplane';
export const PAUSE = 'Pause';
export const PENCIL = 'Pencil';
export const PERFORMANCE = 'Performance';
export const PHONE = 'Phone';
export const PLAY = 'Play';
export const PLUS = 'Plus';
export const SHRUNK_PLUS = 'Plus--shrunk';
export const PROJECT = 'Project';
export const PUSHPIN = 'PushPin';
export const REASSIGN = 'Reassign';
export const RECEIPT = 'Receipt';
export const RETAIL_ANALYTICS = 'RetailAnalytics';
export const RETURN = 'Return';
export const REVIEW = 'Review';
export const ROUTES = 'Routes';
export const SEARCH = 'Search';
export const SELECT = 'Select';
export const SHIELD = 'Shield';
export const SIM = 'SIM';
export const SKULL = 'Skull';
export const SMARTPHONE = 'Smartphone';
export const SPACEBRIDGE = 'Spacebridge';
export const SPACEBRIDGE_SLASH = 'Spacebridge--slash';
export const STAR = 'Star';
export const SYNC = 'Sync';
export const SYSTEM = 'System';
export const TABLE = 'Table';
export const TAG = 'Tag';
export const TRANSFER = 'Transfer';
export const TRASH = 'Trash';
export const TRIANGLE_LINEINTO_SOUTH = 'Triangle--lineinto--south';
export const USER = 'User';
export const WARNING = 'Warning';
